import {Bank} from "@/router/Bank.js";
import {PaySection} from "@/router/PaySection.js";
import {DefaultPaySection} from "@/router/DefaultPaySection.js";
import {AutoPaySection} from "@/router/AutoPaySection.js";
import {OutStateModel} from "@/router/OutStateModel.js";

import {Occupation} from "@/router/Occupation.js";

import {Balance} from "@/router/Absence/Balance.js";
import {AbsenceReason} from "@/router/Absence/AbsenceReason.js";

import {DataSelect} from "@/router/DataSelect.js";

import {PaySlipConfiguration} from "@/router/PaySlip.js";
import {WorkerConfiguration} from "@/router/Worker.js";
import {ValidationWorkFlowConfiguration} from "@/router/Absence/ValidationWorkFlow.js";

import {Configuration} from "@/views/Notification/router/Configuration.js";
import {Alarm} from "@/views/Notification/router/Alarm.js";
import {ControlProgram} from "@/views/Notification/router/ControlProgram.js";
import {ControlIssue} from "@/views/Notification/router/ControlIssue.js"


import {ImportModel} from "@/router/ImportModel.js";
import {Codification} from "@/router/Setting/Codification.js";
import {AdditionalField} from "@/router/Setting/AdditionalField.js";
import {Role} from "@/router/Setting/Role.js";
import {User, UserConfiguration} from "@/router/Setting/User.js";
import {GeneralConfiguration} from "@/router/Parameter/GeneralConfiguration.js";

import {School} from "@/router/Training/School.js"
import {Catalog} from "@/router/Training/Catalog.js"
import {TrainingRequestConfiguration} from "@/router/Training/TrainingRequest.js"
import {
    PaySectionTool,
    OccupationPaySectionTool,
    IrgTool,
    OccupationTool,
    EvaluationMeasureTools,
    EvaluationFileTools,
    ContratTemplateTool,
    ContratTool,
    WorkerTool,
    PaySlipTool,
    CnasAgencyTool,
    DebtTool,
} from "@/router/Tools.js";

import {EvaluationSkillCatalog} from "@/router/Evaluation/Skill/EvaluationSkillCatalog.js";
import {EvaluationSkillGravity} from "@/router/Evaluation/Skill/EvaluationSkillGravity.js";
import {EvaluationSkillCriterion} from "@/router/Evaluation/Skill/EvaluationSkillCriterion.js";
import {EvaluationSkillCriterionCategory} from "@/router/Evaluation/Skill/EvaluationSkillCriterionCategory.js";
import {EvaluationSkillPhase} from "@/router/Evaluation/Skill/EvaluationSkillPhase.js";
import {EvaluationSkillFile} from "@/router/Evaluation/Skill/EvaluationSkillFile.js";

import {EvaluationPerformanceGravity} from "@/router/Evaluation/Performance/EvaluationPerformanceGravity.js";
import {EvaluationPerformanceCriterion} from "@/router/Evaluation/Performance/EvaluationPerformanceCriterion.js";
import {EvaluationPerformanceCriterionCategory} from "@/router/Evaluation/Performance/EvaluationPerformanceCriterionCategory.js";
import {EvaluationPerformancePhase} from "@/router/Evaluation/Performance/EvaluationPerformancePhase.js";
import {EvaluationPerformanceFile} from "@/router/Evaluation/Performance/EvaluationPerformanceFile.js";
import {EvaluationPerformanceFileModel} from "@/router/Evaluation/Performance/EvaluationPerformanceFileModel.js";

import {EvaluationRecruitmentGravity} from "@/router/Evaluation/Recruitment/EvaluationRecruitmentGravity.js";
import {EvaluationRecruitmentCriterion} from "@/router/Evaluation/Recruitment/EvaluationRecruitmentCriterion.js";
import {EvaluationRecruitmentCriterionCategory} from "@/router/Evaluation/Recruitment/EvaluationRecruitmentCriterionCategory.js";
import {EvaluationRecruitmentFile} from "@/router/Evaluation/Recruitment/EvaluationRecruitmentFile.js";

import {EvaluationTrainingHotGravity} from "@/router/Evaluation/TrainingHot/EvaluationTrainingHotGravity.js";
import {EvaluationTrainingHotCriterion} from "@/router/Evaluation/TrainingHot/EvaluationTrainingHotCriterion.js";
import {EvaluationTrainingHotCriterionCategory} from "@/router/Evaluation/TrainingHot/EvaluationTrainingHotCriterionCategory.js";
import {EvaluationTrainingHotFile} from "@/router/Evaluation/TrainingHot/EvaluationTrainingHotFile.js";

import {EvaluationTrainingColdGravity} from "@/router/Evaluation/TrainingCold/EvaluationTrainingColdGravity.js";
import {EvaluationTrainingColdCriterion} from "@/router/Evaluation/TrainingCold/EvaluationTrainingColdCriterion.js";
import {EvaluationTrainingColdCriterionCategory} from "@/router/Evaluation/TrainingCold/EvaluationTrainingColdCriterionCategory.js";
import {EvaluationTrainingColdFile} from "@/router/Evaluation/TrainingCold/EvaluationTrainingColdFile.js";

import {EvaluationPlanConfiguration} from "@/router/Evaluation/EvaluationPlanConfiguration.js";

import {RecruitmentConfiguration} from "@/router/Recruitment/RecruitmentConfiguration";
import {TaskModel} from "@/router/Boarding/TaskModel.js";
import {ProcessModel} from "@/router/Boarding/ProcessModel.js";

import {Template} from "@/router/Edms/Template.js";
import {PersonalizedVariable} from "@/router/Edms/PersonalizedVariable.js";
import {HeaderTemplate} from "@/router/Edms/TemplateHeader.js";
import {FooterTemplate} from "@/router/Edms/TemplateFooter.js";

import {Email} from "@/router/Email";

import {CnasAgency} from "@/router/CnasAgency.js";

import {MedicalConfiguration} from "@/router/Medical/MedicalConfiguration.js";
import {MedicalCenter} from "@/router/Medical/MedicalCenter.js";
import {MedicalReason} from "@/router/Medical/MedicalReason.js";

export const Parameter = {
    path: '/parameters',
    name: 'parameters',
    component: () => import('@/views/Parameter/ParameterPage.vue'),
    children: [
        GeneralConfiguration,
        Bank,
        PaySection,
        DefaultPaySection,
        AutoPaySection,
        OutStateModel,

        Occupation,

        Balance,
        AbsenceReason,

        DataSelect,

        PaySlipConfiguration,
        WorkerConfiguration,
        ValidationWorkFlowConfiguration,

        Configuration,
        Alarm,
        ControlProgram,
        ControlIssue,

        School,
        Catalog,
        TrainingRequestConfiguration,


        OccupationTool,
        EvaluationMeasureTools,
        EvaluationFileTools,
        CnasAgencyTool,
        ContratTemplateTool,
        ContratTool,
        DebtTool,
        WorkerTool,
        PaySectionTool,
        OccupationPaySectionTool,
        PaySlipTool,
        IrgTool,

        EvaluationSkillCatalog,
        EvaluationSkillGravity,
        EvaluationSkillCriterion,
        EvaluationSkillCriterionCategory,
        EvaluationSkillPhase,
        EvaluationSkillFile,

        EvaluationPerformanceGravity,
        EvaluationPerformanceCriterion,
        EvaluationPerformanceCriterionCategory,
        EvaluationPerformancePhase,
        EvaluationPerformanceFile,
        EvaluationPerformanceFileModel,

        EvaluationRecruitmentGravity,
        EvaluationRecruitmentCriterion,
        EvaluationRecruitmentCriterionCategory,
        EvaluationRecruitmentFile,

        EvaluationTrainingHotGravity,
        EvaluationTrainingHotCriterion,
        EvaluationTrainingHotCriterionCategory,
        EvaluationTrainingHotFile,

        EvaluationTrainingColdGravity,
        EvaluationTrainingColdCriterion,
        EvaluationTrainingColdCriterionCategory,
        EvaluationTrainingColdFile,

        EvaluationPlanConfiguration,

        RecruitmentConfiguration,
        TaskModel,
        ProcessModel,

        Template,
        HeaderTemplate,
        FooterTemplate,
        PersonalizedVariable,

        Email,
        CnasAgency,

        MedicalConfiguration,
        MedicalCenter,
        MedicalReason,

        ImportModel,
        Codification,
        AdditionalField,
        Role,
        UserConfiguration,
        User,
    ],
}